function init() {
  const langMenu = document.querySelector('.language')
  const langToggle = document.querySelector('.toggle')
  const navigation = document.querySelector('.regional-navigation')
  const menuToggle = document.querySelector('.menu-toggle')

  langToggle.addEventListener('click', (e) => {
    langMenu.classList.toggle('open')
  }, false)

  menuToggle.addEventListener('click', (e) => {
    navigation.classList.toggle('open')
  }, false)

  window.addEventListener('scroll', (e) => {
    if (window.scrollY > 0) {
      navigation.classList.add('shadow')
    } else {
      navigation.classList.remove('shadow')
    }
  }, false)
}

document.addEventListener('DOMContentLoaded', init)



// WEBPACK FOOTER //
// ./src/assets/js/regionalNavigation.js